module.exports = __webpack_public_path__ + "static/img/credential3.7c8af42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credential/credential3.jpg
// module id = A8DT
// module chunks = 1